module.exports = __webpack_public_path__ + "img/recipe-default-img.be50b0d.webp";